import { render } from "./BankDetailView.vue?vue&type=template&id=7187a48a&scoped=true&ts=true"
import script from "./BankDetailView.vue?vue&type=script&lang=ts"
export * from "./BankDetailView.vue?vue&type=script&lang=ts"

import "./BankDetailView.vue?vue&type=style&index=0&id=7187a48a&scoped=true&lang=css"

import exportComponent from "D:\\Github\\SmsAdminOnlineApplication\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7187a48a"]])

export default __exports__